import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../Text';
import styles from './styles.scss';

export default class Paragraph extends Component {
  static propTypes = {
    id: PropTypes.string,
    text: PropTypes.node,
    children: PropTypes.any,
    className: PropTypes.string,
    lead: PropTypes.bool,
  };

  static defaultProps = {
    id: '',
    className: '',
    lead: false,
  };

  render() {
    const { id, text, children, className, lead } = this.props;
    const classes = classNames(className, {
      [styles.lead]: lead,
    });

    return React.createElement('p', { id, className: classes }, children || <Text item={text} />);
  }
}
